var map = {
	"./energy-banner.png": 3322,
	"./sleep-banner.png": 8005,
	"./sooth-banner.png": 6069,
	"./sunrise-banner.png": 2182,
	"./sunset-banner.png": 4540,
	"./young-banner.png": 2439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2003;